const MAP_SELECTOR = '.locator-map__google-map'

const MAP_STYLE = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]

const MAP_OPTIONS = {
  selectors: {
    form: '.locator-form',
    list: '.locations-list',
    where: 'input[name="where"]',
    radius: 'select[name="radius"]',
    limit: 'select[name="limit"]',
  },
  basicOptions: {
    zoom: 10,
    maxZoom: 18,
    minZoom: 5,
    lat: 45.60495258760901,
    lng: -73.71906734960938,
    mapStyle: MAP_STYLE,
    autoFadeIn: true,
    autoFitBounds: 'geolocation',
    enableGeolocation: false,
    enablePositionMarker: false,
    searchAfterGeolocation: true,
    putSearchParametersInURL: false,
  },
  clusterOptions: {
    useClusters: false,
  },
  bubbleOptions: {
    useBubbles: false,
  },
  getMarkerIcon: function() {
    let markerIcon = {
      url: '/img/elements/map-marker.svg',
      height: 30,
      width: 30,
      anchorX: 15,
      anchorY: 15,
      scaledWidth: 30,
      scaledHeight: 30,
    }
    return markerIcon
  },
}

let self

export default {
  locator: undefined,
  locations: [],

  init() {
    self = this
    this.attachEvents()
  },

  markerClicked(event, locator, marker) {
    $('.location-item').removeClass('location-item--selected')
    let locationItem = $('.location-item[data-id=' + marker.location.id + ']')
    locationItem.addClass('location-item--selected')
    $('html, body').scrollTo(locationItem.offset().top - $('.header').outerHeight() - 16, 'easeInOutQuart')
  },

  geolocateList(event, locator) {
    let locationItems = $('.locations-list .location-item').detach().sort(function(a, b) {
      let
      aLng = parseFloat($(a).data('lng')),
      bLng = parseFloat($(b).data('lng')),
      uLng = locator.current.lng,
      aLat = parseFloat($(a).data('lat')),
      bLat = parseFloat($(b).data('lat')),
      uLat = locator.current.lat,
      aDeltaLng = Math.abs(uLng - aLng),
      aDeltaLat = Math.abs(uLat - aLat),
      bDeltaLng = Math.abs(uLng - bLng),
      bDeltaLat = Math.abs(uLat - bLat),
      aDistance = Math.sqrt(aDeltaLng * aDeltaLng + aDeltaLat * aDeltaLat),
      bDistance = Math.sqrt(bDeltaLng * bDeltaLng + bDeltaLat * bDeltaLat)
      return aDistance > bDistance ? 1 : -1
    })
    // $('.locations-list').append(locationItems)
  },

  attachEvents() {
    if ($(MAP_SELECTOR).length || $('.locations-list').length) {
      /* Initialize map when ready */
      if ("MLMI_Locator_Function" in window) {
        $.fn.MLMI_Locator = window.MLMI_Locator_Function
      }
      if ($.fn.MLMI_Locator == undefined) {
        setTimeout(self.attachEvents, 50)
      } else {
        /* Initialize map */
        if ($.mlmi.mobile.isMobile) {
          MAP_OPTIONS.basicOptions.zoom = 9
        }
        if ($(MAP_SELECTOR).length) {
          self.locator = $(MAP_SELECTOR).MLMI_Locator(MAP_OPTIONS)
        } else {
          self.locator = $('<div>').MLMI_Locator(MAP_OPTIONS)
        }

        /* Get locations for filtering */
        if ("locations" in window) {
          self.locations = window.locations
        }

        /* Order locations after geolocations */
        self.locator.on('geolocation_accepted', self.geolocateList)

        /* Marker clicked */
        self.locator.on('marker_clicked', self.markerClicked)
      }
    }
  },
}
